<template>
  <r-panel :disabled="disabled" :title="title">
    <r-currency-table :items.sync="value.currencies" title="Currency"/>
    <v-divider/>
    <r-ticket-table :items.sync="value.tickets" title="Ticket" class="pt-4" v-if="ticket"/>
  </r-panel>
</template>

<script>
import VueTypes from "vue-types";
import {Money} from "@/modules/redactor/models/currency/Money";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RCurrencyTable from "@/modules/redactor/views/currency/r-currency-table.vue";
import RTicketTable from "@/modules/redactor/views/currency/r-ticket-table.vue";

export default {
  name: "r-money-panel",
  components: {RTicketTable, RCurrencyTable, RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Money"),
    model: VueTypes.instanceOf(Money),
    ticket: VueTypes.bool.def(true)
  },
  computed: {
    value() {
      if (this.model) {
        return this.model;
      } else {
        let value = new Money();
        this.$emit("update:model", value);
        return value;
      }
    }
  }
}

</script>